import { buildScopedPath } from "./account-context";
import { ROUTE_PATHS } from "../routes/path-map";

/** After email/Google signup, land on Starter Home (checklist), not Plans dump. */
export const SAAS_POST_SIGNUP_SEGMENT = ROUTE_PATHS.starterHome;

export function buildPostSignupPath(accountId) {
  return buildScopedPath(accountId, SAAS_POST_SIGNUP_SEGMENT);
}
